import http from "../http-common";

const getAll = () => {
  return http.get("/showcase/list");
};

const create = (data) => {
  return http.post("/showcase", data);
};

const updateDetails = (id, data) => {
  return http.put(`/showcase/${id}`, data);
};

const updateBooks = (id, data) => {
  return http.post(`/showcase/books/${id}`, data);
};

const remove = (id) => {
  return http.delete(`/showcase/${id}`);
};

const ShowcaseService = {
  getAll,
  create,
  updateDetails,
  updateBooks,
  remove,
};

export default ShowcaseService;
